import { unsentFilingsOfProjectChanged } from 'store/projects/actions/verottajailmoitettava.actions';
import { getProjectsActivityFilterCacheKey } from 'store/projects/utils/getProjectsActivityFilterCacheKey';
import {
  getUnsentFilingsSourceMonthKeys,
  hasOtherUnsentFilingInSourceMonths,
  isUnsentFilingInSourceMonths,
} from 'store/projects/utils/unsentFilingsSourceMonths';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

const getHasUnsentFilings = (
  state,
  { projectId, removedFilingId, addedFiling }
) => {
  if (addedFiling) {
    const monthKeys = getUnsentFilingsSourceMonthKeys();

    // Outside those months the new filing does not say: other filings might.
    return isUnsentFilingInSourceMonths(addedFiling, monthKeys) ? true : null;
  }

  // The filings page loads every filing of its project into the store. When
  // the changed filing is not among them, they say nothing about the project.
  const filings = Object.values(state.filings?.filings?.entities || {});

  if (!removedFilingId || !filings.some(({ id }) => id === removedFilingId)) {
    return null;
  }

  return hasOtherUnsentFilingInSourceMonths(filings, {
    projectId,
    exceptFilingId: removedFilingId,
  });
};

/**
 * Tells the Verottajailmoitettavat project list that a filing of
 * `change.projectId` was sent or deleted (`removedFilingId`) or created
 * (`addedFiling`), so a project with nothing left to send leaves the list
 * without a reload.
 *
 * `stateBeforeChange` is the state the sending or deleting thunk started
 * from: leaving the filings page while the API call runs empties the filings
 * store, so its filings are read from there.
 *
 * Dispatched once the API call has succeeded, so it never throws: a list that
 * cannot be updated must not turn a sent filing into a failed one.
 */
export const reportUnsentFilingsChange =
  (change, stateBeforeChange) => (dispatch, getState) => {
    try {
      const state = stateBeforeChange || getState();
      const cacheKey = getProjectsActivityFilterCacheKey(
        selectUserActiveEmployerInfo(state)
      );

      if (!cacheKey || !change?.projectId) {
        return;
      }

      dispatch(
        unsentFilingsOfProjectChanged({
          cacheKey,
          projectId: change.projectId,
          hasUnsentFilings: getHasUnsentFilings(state, change),
        })
      );
    } catch (error) {
      console.error(
        'Could not update the Verottajailmoitettavat list after a filing change',
        error
      );
    }
  };
